// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"73":"css/selkbags","415":"css/samuraknives","489":"css/edctools","523":"css/niteize","580":"css/spyderco","627":"css/olight"}[chunkId] + ".css";
};